import type { AnchorHTMLAttributes, HTMLAttributes, ReactNode } from "react";
import type {
  TSocialProofCardItems,
} from "@/ui/components/data-display/Card/SocialProofCard";
import type { TImageProps } from "@/ui/components/primitives";
import type { DefinedDefaults, TWithDataComponent } from "@/ui/lib";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const SOCIAL_MEDIA_CALLOUT_SCROLL_FADE_CLASS =
  "pointer-events-none absolute inset-x-0 bottom-0 z-[1] h-40 bg-gradient-to-t from-sys-neutral-600";

/*-------------------------------------
|  Types
-------------------------------------*/

export type TSocialMediaCalloutCta = {
  href: string;
  label: ReactNode;
  target?: AnchorHTMLAttributes<HTMLAnchorElement>["target"];
  rel?: AnchorHTMLAttributes<HTMLAnchorElement>["rel"];
};

export type TSocialMediaCalloutProps = Omit<HTMLAttributes<HTMLElement>, "title"> & TWithDataComponent & {
  items: TSocialProofCardItems;
  footerImages: TImageProps[];
  memberCount: number;
  cta: TSocialMediaCalloutCta;
  title: ReactNode;
  body: ReactNode;
  footer: (values: { firstName: string; memberCount: number }) => ReactNode;
};

type TSocialMediaCalloutDefaultProps = DefinedDefaults<
  TSocialMediaCalloutProps,
  "data-component"
>;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const SOCIAL_MEDIA_CALLOUT_DEFAULTS = {
  "data-component": "SocialMediaCallout",
} satisfies TSocialMediaCalloutDefaultProps;
